import axios from "axios";
import Cookies from "js-cookie";
import { loginService } from "../loginService";

// DataVerse URLs
const DEV_URL = "https://agora-recruitment.crm8.dynamics.com";
const PROD_URL = "https://talenthub.crm8.dynamics.com";

const currentOrigin = window.location.origin;
const RESOURCE_URL =
  currentOrigin === "https://talenthub.intelegain.com" ? PROD_URL : DEV_URL;

const axiosInstance = axios.create({
  baseURL: RESOURCE_URL + `/api/data/v9.2`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Response Interceptor to handle 401 and refresh token silently
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      const isCandidateFeedbackPage =
        window.location.pathname.startsWith("/candidatefeedback/") ||
        window.location.pathname.startsWith("/candidate-form/");

      if (isCandidateFeedbackPage) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const payload = {
          grant_type: "client_credentials",
          resource: RESOURCE_URL,
        };
        const response = await loginService.getDataverseToken(payload);
        if (response.status === 200) {
          const newToken = response.data.access_token;
          Cookies.set("token", newToken, { expires: 1 });
          
          axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          
          processQueue(null, newToken);
          isRefreshing = false;
          
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshing = false;
        
        // If token refresh fails, clear token and redirect to login
        Cookies.remove("token");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
